require('animate');
const React = require('react');
const App = require('./app');
const ReactDOM = require('react-dom');
import {IntlProvider} from 'react-intl';
import {addLocaleData} from 'react-intl';
import br from 'react-intl/locale-data/br';

function runMyApp() {
  addLocaleData(br);
  ReactDOM.render(<IntlProvider locale="br"><App /></IntlProvider>, document.getElementById('app-container'));
}

if (!window.Intl) {
  // hello safari
  require.ensure(['intl/dist/Intl'], (require) => {
    window.Intl = require('intl/dist/Intl');
    runMyApp();
  }, "IntlBundle");
}
else {
  // hello chrome, ie, etc.!
  runMyApp();
}


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/